export default [  
  {
    path: '/notifications',
    props: true,
    name: 'notifications',
    component: () => import('@/views/modules/notifications/notifications'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Notifications',
      breadcrumb: [
        { text: 'Home', to: {name:'home'} },
        { text: 'Notifications' }
      ]
    }
  },
]